const STORAGE_KEY = '__luckynoteMasonryVideoMuted';
export const MASONRY_VIDEO_MUTE_CHANGED_EVENT = 'luckynote:masonry-video-mute-changed';

export const getMasonryVideoMuted = () => {
    if (typeof window === 'undefined') {
        return true;
    }

    return window[STORAGE_KEY] !== false;
};

// Persists the preference and broadcasts it so every currently-mounted video
// (not just future ones) can react live: unmuting one video unmutes all the
// others, and vice versa.
export const setMasonryVideoMuted = value => {
    if (typeof window === 'undefined') {
        return;
    }

    const nextMuted = value !== false;
    window[STORAGE_KEY] = nextMuted;
    window.dispatchEvent(new CustomEvent(MASONRY_VIDEO_MUTE_CHANGED_EVENT, { detail: nextMuted }));
};

export const subscribeMasonryVideoMuted = callback => {
    if (typeof window === 'undefined') {
        return () => {};
    }

    const handler = event => callback(Boolean(event.detail));
    window.addEventListener(MASONRY_VIDEO_MUTE_CHANGED_EVENT, handler);
    return () => window.removeEventListener(MASONRY_VIDEO_MUTE_CHANGED_EVENT, handler);
};
